import {
  Section,
  Container,
  BlogCard,
  Heading,
  Statistics,
  CryptoHistory,
  ForbesList,
} from 'components';

import stats from 'data/stats.json';

import article from 'data/article.json';
import forbes from 'data/forbes.json';
import transactionsHistory from 'data/transactions.json';

export const App = () => {
  return (
    <Section>
      <Container>
        <Heading title="Task 1 Blog Card" bottom />
        <BlogCard {...article} />
        <Heading title="Task 2 Statistics" top bottom />
        <Statistics title="Main Statistics" stats={stats} />
        <Heading title="Task 3 Forbes list" top bottom />
        <ForbesList list={forbes} />
        <Heading title="Task 4 Crypto history" top bottom />
        <CryptoHistory transactionsHistory={transactionsHistory} />
      </Container>
    </Section>
  );
};
